export enum RequestStatuses {
  Requested = <any>'requested', // cannot use string
  Error = <any>'error',
  Completed = <any>'complete'
}

